var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.selectedNode)?_c('t-node-summary',{attrs:{"title":_vm.selectedNode.title,"type":_vm.selectedNodeType}},[(_vm.editor)?_c(_vm.editor,{tag:"div",attrs:{"flow":_vm.flow,"value":_vm.selectedNode,"type":_vm.selectedNodeType,"startupTypes":_vm.startupTypes}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }